import view from './reset-password'
export default view
